import { buildCssVar } from 'utils/style-override';

import type { ComponentsImageCarousel } from 'queries/graphql';

import AutoplayCarousel from './components/AutoplayCarouselTheme';

// This is legacy I believe
// import BlazeImageCarousel from './components/BlazeImageCarousel';

import styles from './styles.module.scss';

export default function ImageCarousel({
  sectionId,
  images,
  showThumbnailsOnDesktop,
  imageProgressDisplayOnMobile,
  style,
}: ComponentsImageCarousel) {
  const { backgroundColor, buttonColor } = style || {};

  return (
    <div id={sectionId} className={`root ${styles.container}`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--background-color', backgroundColor, 'var(--default-background-color)')}
        }
      `}</style>

      {/* <BlazeImageCarousel images={images} /> */}

      <AutoplayCarousel
        showButtons
        buttonColor={buttonColor}
        showDots
        shouldLoop
        shouldAutoplay={false}
        alignment="center"
        items={images}
        showThumbnails={showThumbnailsOnDesktop}
        imageProgressDisplayOnMobile={imageProgressDisplayOnMobile}
      />
    </div>
  );
}
